import React from 'react';
import PublicIcon from '@material-ui/icons/Public';
import {
    ContainerFieldsList,
    CustomBreadcrumbs,
    CustomSelectInput,
} from 'candy-commons-components';
import {
    BooleanInput,
    Create,
    required,
    SimpleForm,
    TextInput,
    useTranslate,
} from 'react-admin';
import BRAND_CHOICES from '../../data/ecommerceBrandChoices.json';

const validateCountry = (value) => {
    if (!value) return 'Country is required';
    const upperValue = value.toUpperCase();
    if (upperValue.length < 2 || upperValue.length > 3) {
        return 'Country code must be 2-3 characters (e.g., IT, DE, UK)';
    }
    if (!/^[A-Z]+$/.test(upperValue)) {
        return 'Country code must contain only letters';
    }
    return undefined;
};

const EcommerceCountryConfigCreate = (props) => {
    const translation = useTranslate();
    const breadcrumbsData = [
        {
            text: translation(
                'resources.ecommerce-country-config.name',
                'Ecommerce Country Configuration'
            ),
            url: 'ecommerce-country-config',
            icon: <PublicIcon />,
        },
        {
            text: translation(
                'resources.ecommerce-country-config.create.name',
                'Create'
            ),
            url: '',
        },
    ];

    const transform = (data) => ({
        ...data,
        brand: data.brand?.toUpperCase(),
        country: data.country?.toUpperCase(),
    });

    return (
        <>
            <CustomBreadcrumbs data={breadcrumbsData} />
            <Create {...props} transform={transform}>
                <SimpleForm redirect="list">
                    <ContainerFieldsList>
                        <CustomSelectInput
                            source="brand"
                            choices={BRAND_CHOICES}
                            validate={[required()]}
                            label="Brand"
                        />
                        <TextInput
                            source="country"
                            label="Country Code"
                            validate={[required(), validateCountry]}
                            helperText="ISO country code (e.g., IT, DE, UK, FR, ES)"
                        />
                        <BooleanInput
                            source="enabled"
                            label="Enabled"
                            defaultValue={false}
                        />
                    </ContainerFieldsList>
                </SimpleForm>
            </Create>
        </>
    );
};

export default EcommerceCountryConfigCreate;
